<template>
    <div></div>
</template>

<script>
export default {
    data: () => ({}),

    created() {},

    mounted() {},

    computed: {},

    methods: {}
}
</script>

<style lang="scss" scoped>
.avatar-offline:after,
.avatar-online:after {
    @apply absolute bottom-0 w-2 h-2;
    content: "";
    right: 2px;
    border-radius: 100%;
    box-shadow: 0 0 0 2px #fff;
}

.avatar-offline:after {
    @apply bg-gray-400;
    /*~ background-color: #c0ccda; */
}

.avatar-online:after {
    @apply bg-green-600;
    /*~ background-color: #10b759; */
}

.avatar-sm.avatar-offline:after,
.avatar-sm.avatar-online:after {
    @apply w-2 h-2;
}

.avatar-lg.avatar-offline:after,
.avatar-lg.avatar-online:after {
    @apply w-2 h-2;
    bottom: 3px;
    right: 4px;
}
</style>
